// Common validation rules for Vuetify 3
// Usage: <v-text-field :rules="[required, minLength(3)]" />

export const required = (v) => !!v || 'Pflichtfeld'

export const requiredIf = (condition) => (v) =>
  !condition || !!v || 'Pflichtfeld'

export const minLength = (min) => (v) =>
  !v || v.length >= min || `Mindestlänge: ${min} Zeichen`

export const maxLength = (max) => (v) =>
  !v || v.length <= max || `Maximale Länge: ${max} Zeichen`

export const minValue = (min) => (v) =>
  v === null || v === '' || v >= min || `Mindestwert: ${min}`

export const maxValue = (max) => (v) =>
  v === null || v === '' || v <= max || `Maximalwert: ${max}`

export const email = (v) =>
  !v || /.+@.+\..+/.test(v) || 'Ungültige E-Mail-Adresse'

export const url = (v) =>
  !v ||
  /^https?:\/\/.+/.test(v) ||
  'Ungültige URL (muss mit http:// oder https:// beginnen)'

export const regex = (pattern, message = 'Ungültiges Format') => (v) =>
  !v || pattern.test(v) || message

export const numeric = (v) =>
  !v || /^\d+$/.test(v) || 'Muss eine Zahl sein'

export const alpha = (v) =>
  !v || /^[a-zA-Z]+$/.test(v) || 'Darf nur Buchstaben enthalten'

export const alphaNum = (v) =>
  !v || /^[a-zA-Z0-9]+$/.test(v) || 'Darf nur Buchstaben und Zahlen enthalten'

export const requiredArray = (v) =>
  (Array.isArray(v) && v.length > 0) || 'Mindestens ein Eintrag erforderlich'

export const dateInFuture = (v) => {
  if (!v) return true
  const date = new Date(v)
  return date > new Date() || 'Datum muss in der Zukunft liegen'
}

export const dateInPast = (v) => {
  if (!v) return true
  const date = new Date(v)
  return date < new Date() || 'Datum muss in der Vergangenheit liegen'
}

export function combineValidators(...validators) {
  return (v) => {
    for (const validator of validators) {
      const result = validator(v)
      if (result !== true) return result
    }
    return true
  }
}
